// Close Facets

document.addEventListener('click', function (e) {
    const openFilter = document.querySelector('.facet-accordion-details[open]');
    const clickedFilter = e.target.closest('.facet-accordion-details');

    if (!openFilter) return;

    if (!clickedFilter || clickedFilter !== openFilter) {
        openFilter.querySelector('summary').click();
    }
}, true);